// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── User AD Lookup ──────────────────────────────────────────────────────── */

.ecr-user-lookup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Search bar */
.ecr-user-lookup__search-wrap {
  display: flex;
  align-items: stretch;
}

/* Skeleton / loading */
.ecr-user-lookup__skeleton-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

/* User card */
.ecr-user-lookup__card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 28px 32px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.ecr-user-lookup__card-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.ecr-user-lookup__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #86BC25, #5a8015);
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 1px;
}

.ecr-user-lookup__card-name {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
  margin: 0 0 2px;
}

.ecr-user-lookup__card-title {
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 8px;
}

.ecr-user-lookup__card-badge {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #86BC25;
  background: #e6f6ee;
  border: 1px solid #b2e8cc;
  padding: 2px 8px;
  border-radius: 20px;
}

/* Fields */
.ecr-user-lookup__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;
}

.ecr-user-lookup__field {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.ecr-user-lookup__field-icon {
  color: #86BC25;
  margin-top: 2px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.ecr-user-lookup__field-icon svg {
  font-size: 18px;
}

.ecr-user-lookup__field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
  margin: 0 0 2px;
}

.ecr-user-lookup__field-value {
  font-size: 13px;
  color: #111827;
  margin: 0;
  word-break: break-word;
}

.ecr-user-lookup__field-empty {
  color: #d1d5db;
}

/* Groups */
.ecr-user-lookup__groups-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.ecr-user-lookup__groups-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ecr-user-lookup__group-chip {
  font-size: 11px;
  font-weight: 500;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 3px 10px;
  border-radius: 20px;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

/* Raw JSON */
.ecr-user-lookup__raw {
  margin-top: 20px;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  overflow: hidden;
}

.ecr-user-lookup__raw summary {
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  background: #f9fafb;
  -webkit-user-select: none;
          user-select: none;
}

.ecr-user-lookup__raw pre {
  padding: 16px;
  margin: 0;
  font-size: 11px;
  color: #374151;
  background: #f9fafb;
  overflow-x: auto;
  max-height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/ActiveDirectoryUserLookup.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* ── User AD Lookup ──────────────────────────────────────────────────────── */\n\n.ecr-user-lookup {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Search bar */\n.ecr-user-lookup__search-wrap {\n  display: flex;\n  align-items: stretch;\n}\n\n/* Skeleton / loading */\n.ecr-user-lookup__skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 24px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n/* User card */\n.ecr-user-lookup__card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 28px 32px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n.ecr-user-lookup__card-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.ecr-user-lookup__avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #86BC25, #5a8015);\n  color: #fff;\n  font-size: 22px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 1px;\n}\n\n.ecr-user-lookup__card-name {\n  font-size: 20px;\n  font-weight: 800;\n  color: #111827;\n  margin: 0 0 2px;\n}\n\n.ecr-user-lookup__card-title {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0 0 8px;\n}\n\n.ecr-user-lookup__card-badge {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #86BC25;\n  background: #e6f6ee;\n  border: 1px solid #b2e8cc;\n  padding: 2px 8px;\n  border-radius: 20px;\n}\n\n/* Fields */\n.ecr-user-lookup__fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 32px;\n}\n\n.ecr-user-lookup__field {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.ecr-user-lookup__field-icon {\n  color: #86BC25;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.ecr-user-lookup__field-icon svg {\n  font-size: 18px;\n}\n\n.ecr-user-lookup__field-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9ca3af;\n  margin: 0 0 2px;\n}\n\n.ecr-user-lookup__field-value {\n  font-size: 13px;\n  color: #111827;\n  margin: 0;\n  word-break: break-word;\n}\n\n.ecr-user-lookup__field-empty {\n  color: #d1d5db;\n}\n\n/* Groups */\n.ecr-user-lookup__groups-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 10px;\n}\n\n.ecr-user-lookup__groups-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ecr-user-lookup__group-chip {\n  font-size: 11px;\n  font-weight: 500;\n  color: #374151;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  padding: 3px 10px;\n  border-radius: 20px;\n  cursor: default;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n/* Raw JSON */\n.ecr-user-lookup__raw {\n  margin-top: 20px;\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ecr-user-lookup__raw summary {\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  background: #f9fafb;\n  user-select: none;\n}\n\n.ecr-user-lookup__raw pre {\n  padding: 16px;\n  margin: 0;\n  font-size: 11px;\n  color: #374151;\n  background: #f9fafb;\n  overflow-x: auto;\n  max-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
